export const PAYMENT = "eae687ed-8604-11e9-9dbc-0242ac120002";
export const COMPLETION = "fd7403b7-8604-11e9-9dbc-0242ac120002";
export const GENERAL = "f3cd6c00-8604-11e9-9dbc-0242ac120002";

export const guaranteeTypeList = [
  { name: "Payment", value: PAYMENT },
  { name: "Completion", value: COMPLETION },
  { name: "General", value: GENERAL }
];
